export const GENDER = [
  { text: 'Male', value: 'Male' },
  { text: 'Female', value: 'Female' },
  { text: 'Not Applicable', value: 'Not Applicable' },
];
export default GENDER;



// WEBPACK FOOTER //
// ./src/constants/gender.js